<div class="price-label" [class.price-label--disabled]="disabled()">
  <div class="price-label__label">
    <div class="price-label__label__from">{{ disabled() ? fromLabel : priceLabel() }}</div>
    <div class="price-label__label__promo" *ngIf="discount() && !disabled()" data-qa="priceLabel_discount">{{ discount() }}</div>
  </div>
  <div class="price-label__price">
    <div class="price-label__price__price" *ngIf="!(price() | lxEqual : endPrice() : [{ property: 'value' }])" data-qa="priceLabel_price">
      {{ price() | lxPrice : { currency: currency() } }}
    </div>
    <div class="price-label__price__end-price" data-qa="priceLabel_endPrice">{{ endPrice() | lxPrice : { currency: currency() } }}</div>
  </div>
</div>
